module.exports = __webpack_public_path__ + "static/media/nodejs.b337a2fb.svg";